import {equals} from 'ramda';

import type {ConfigurationSelection, ProposedDiscount} from '@dms/api/new-vehicle';

export type ReviewPriceSource = 'saved' | 'live';

const normalizeSelection = (selection: ConfigurationSelection) => ({
  ...selection,
  colourId: selection.colourId ?? null,
  upholsteryId: selection.upholsteryId ?? null,
  featureIds: [...selection.featureIds].sort(),
  packageIds: [...selection.packageIds].sort(),
});

export const getReviewPriceSource = (
  savedSelection: ConfigurationSelection | undefined,
  savedDiscount: ProposedDiscount | null | undefined,
  currentSelection: ConfigurationSelection,
  currentDiscount: ProposedDiscount | undefined
): ReviewPriceSource =>
  savedSelection &&
  equals(normalizeSelection(savedSelection), normalizeSelection(currentSelection)) &&
  equals(savedDiscount ?? null, currentDiscount ?? null)
    ? 'saved'
    : 'live';
